import React, { useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import PostRequest from '../../../../service/PostRequest';
import GetRequest from '../../../../service/GetRequest';
import InputFieldIconText from '../../../../components/Widgets/Inputs/InputFieldIconText';
import InputPassword from '../../../../components/Widgets/Inputs/InputPassword';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import "./WhatsappRegister.scss";
import BOSS_mainlogo from '../../../../assets/icons/BOSS_mainlogo.svg';


const RegistrationForm = ({ plan }) => {

    const navigate = useNavigate();
    const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
    const toastBottomCenter = useRef(null);

    const [fullName, setFullName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [fullNameError, setFullNameError] = useState("");
    const [phoneNumberError, setPhoneNumberError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");

    const showMessage = (message, ref, severity) => {
        ref.current.show({ severity: severity, summary: message, detail: message, life: 3000 });
    };

    const validatePassword = () => {
        const passwordMinLength = 8;
        const passwordHasUpperCase = /[A-Z]/;
        const passwordHasLowerCase = /[a-z]/;
        const passwordHasNumber = /\d/;
        const passwordHasSpecialChar = /[@$!%*?&]/;
        const passwordInvalidChar = /[^A-Za-z\d@$!%*?&]/;

        if (!password.trim()) {
            setPasswordError("Password is required");
            return false;
        } else if (password.length < passwordMinLength) {
            setPasswordError(`Password must be at least ${passwordMinLength} characters with special characters`);
            return false;
        } else if (!passwordHasUpperCase.test(password)) {
            setPasswordError("Password must contain at least one uppercase letter");
            return false;
        } else if (!passwordHasLowerCase.test(password)) {
            setPasswordError("Password must contain at least one lowercase letter");
            return false;
        } else if (!passwordHasNumber.test(password)) {
            setPasswordError("Password must contain at least one number");
            return false;
        } else if (!passwordHasSpecialChar.test(password)) {
            setPasswordError("Password must contain at least one special character (@$!%*?&)");
            return false;
        } else if (passwordInvalidChar.test(password)) {
            setPasswordError("Password contains invalid characters");
            return false;
        }

        setPasswordError("");
        return true;
    };
    const handleExistingPhoneNumberCheck = async () => {
        setIsWaitingForResponse(true);
        await GetRequest(`auth/validate/whatsapp?phoneNumber=+${phoneNumber}`)
           .then(response => {
                if (response.data) {
                    setPhoneNumberError("WhatsApp Number already exists");
                } else {
                    setPhoneNumberError("");
                }
                setIsWaitingForResponse(false);
            })
           .catch(error => {
                console.error(error);
                setPhoneNumberError("An error occurred while checking Phone Number");
                setIsWaitingForResponse(false);
            });
    }
    const validateConfirmPassword = () => {
        if (!confirmPassword.trim()) {
            setConfirmPasswordError("Confirm Password is required");
            return false;
        } else if (password !== confirmPassword) {
            setConfirmPasswordError("Passwords do not match");
            return false;
        }

        setConfirmPasswordError("");
        return true;
    };

    const completeSetup = async () => {
        setFullNameError("");
        setPasswordError("");
        setConfirmPasswordError("");

        let isValid = true;

        if (!phoneNumber.trim()) {
            setPhoneNumberError("Phone Number is required");
            isValid = false;
        }

        if (!fullName.trim()) {
            setFullNameError("Full Name is required");
            isValid = false;
        }

        if (!validatePassword() || !validateConfirmPassword()) {
            isValid = false;
        }

        if (phoneNumber && isValid) {
           if(phoneNumberError.length > 0) {
            isValid = false;
           }
        }
        const data = {
            fullName: fullName,
            phoneNumber: `+${phoneNumber}`,
            password: password,
        };

        if (isValid) {
            setIsWaitingForResponse(true);
            await PostRequest(`auth/store/register?planDetails=${plan}`, data, false)
                .then(response => {
                    setIsWaitingForResponse(false);
                    if (response) {
                        navigate("/verify-number", { state: { phoneNumber } });
                    } else {
                        showMessage("Registration failed", toastBottomCenter, 'danger');
                    }
                })
                .catch(() => {
                    setIsWaitingForResponse(false);
                    showMessage("Registration failed", toastBottomCenter, 'danger');
                });
        }
    };

    const handleFullNameChange = (e) => {
        setFullName(e.target.value);
        setFullNameError("");
    };

    const handlePhoneNumberChange = (phone) => {
        setPhoneNumber(phone);
        setPhoneNumberError("");
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setPasswordError("");
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        setConfirmPasswordError("");
    };

    return (
        <div className='WhatsappRegisterContainer'>
            <div className='Heading'>
                <img src={BOSS_mainlogo} alt="BOSS Logo" />
                <h3>Create an account using WhatsApp Number</h3>
            </div>
            <div className='WholeForm'>
                <div className='NameInput'>
                    <label>Full Name</label>
                    <InputFieldIconText value={fullName} onChange={handleFullNameChange} label="Full name" errorMessage={fullNameError} inputIcon="pi pi-user" />
                </div>
                <div className='PhoneNumberInput'>
                    <label>WhatsApp Number</label>
                    <PhoneInput
                        country={"gb"}
                        enableSearch={true}
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        onBlur={handleExistingPhoneNumberCheck}
                    />
                    {phoneNumberError && <div className="error-message">{phoneNumberError}</div>}
                </div>
                <div className='PasswordInput'>
                    <label>Password</label>
                    <InputPassword 
                        value={password} 
                        label="Password" 
                        onChange={handlePasswordChange} 
                        errorMessage={passwordError} 
                    />
                </div>
                    {passwordError && <div style={{color:"red",width:"340px"}}>{passwordError}</div>}
                <div className='PasswordInput'>
                    <label>Confirm Password</label>
                    <InputPassword 
                        value={confirmPassword} 
                        label="Confirm Password" 
                        onChange={handleConfirmPasswordChange} 
                        errorMessage={confirmPasswordError} 
                    />
                    {confirmPasswordError && <div className="error-message">{confirmPasswordError}</div>}
                </div>
                <Button label="Create An Account" severity="primary" onClick={completeSetup} style={{ width: "355px", borderRadius: "40px", marginTop: "20px" }} disabled={isWaitingForResponse} loading={isWaitingForResponse} />
                <div className='LoginText'>
                    <p>Already have an Account? Click here to <span className="text-span" onClick={() => navigate("/login")}>Login</span></p>
                </div>
            </div>
            <Toast ref={toastBottomCenter} position="bottom-center" />
        </div>
    );
};

export default RegistrationForm;
